import React from 'react';
import { Link } from 'react-router-dom';
import './CopyRight.css';

const formatDate = () =>
  new Date().toLocaleDateString('es-AR', { day: 'numeric', month: 'long', year: 'numeric' });

const Copyright = () => {
  return (
    <main className="legal-wrapper" aria-labelledby="legal-title">
      <header className="legal-hero">
        <h1 id="legal-title" className="legal-title">Términos y Condiciones</h1>
        <p className="legal-subtitle">Incluye política de Copyright y uso de imágenes</p>
        <p className="legal-updated">Última actualización: {formatDate()}</p>
      </header>

      {/* Índice */}
      <nav className="legal-toc" aria-label="Índice de secciones">
        <a href="#propiedad">1. Propiedad Intelectual y Copyright</a>
        <a href="#licencia">2. Licencia de uso del sitio</a>
        <a href="#prohibido">3. Usos prohibidos</a>
        <a href="#compras">4. Compras y precios</a>
        <a href="#envios">5. Envíos y plazos</a>
        <a href="#cambios">6. Cambios, cancelaciones y devoluciones</a>
        <a href="#cuentas">7. Cuentas de usuario</a>
        <a href="#responsabilidad">8. Responsabilidad</a>
        <a href="#jurisdiccion">9. Ley aplicable</a>
        <a href="#contacto">10. Contacto</a>
      </nav>

      <section id="propiedad" className="legal-section">
        <h2>1. Propiedad Intelectual y Copyright</h2>
        <p>
          Todas las fotografías, imágenes, diseños, textos, logotipos y cualquier otro contenido
          publicado en este sitio web pertenecen a su autor/fotógrafo y se encuentran protegidos
          por las leyes de derecho de autor vigentes (p. ej., en Argentina, Ley 11.723) y por
          tratados internacionales. <strong>No se concede ninguna cesión de derechos</strong> sobre
          dichos contenidos salvo lo expresamente indicado en estos Términos.
        </p>
        <p>
          Queda <strong>terminantemente prohibido</strong> copiar, descargar, reproducir, imprimir,
          distribuir, publicar, comunicar, vender, sublicenciar, remover marcas de agua o metadatos,
          o utilizar las imágenes para fines comerciales, publicitarios, editoriales, de merchandising,
          o para entrenar modelos de IA, <em>sin licencia o autorización previa y por escrito</em> del autor.
        </p>
      </section>

      <section id="licencia" className="legal-section">
        <h2>2. Licencia de uso del sitio</h2>
        <p>
          Se otorga una licencia limitada, no exclusiva y revocable para <strong>visualizar</strong>
           el sitio en tus dispositivos personales con fines informativos y de compra. Esta licencia
          no permite descargar o almacenar copias de las imágenes (excepto el caché técnico del navegador).
        </p>
      </section>

      <section id="prohibido" className="legal-section">
        <h2>3. Usos prohibidos</h2>
        <ul className="legal-list">
          <li>Realizar capturas o descargas de imágenes para cualquier uso no autorizado.</li>
          <li>Eliminar, ocultar o alterar marcas de agua, firmas o créditos.</li>
          <li>Subir las obras a bancos de imágenes o redes sociales como propias.</li>
          <li>Extraer datos o hacer scraping masivo del sitio.</li>
          <li>Eludir medidas técnicas de protección o seguridad del sitio.</li>
          <li>Usar las imágenes para entrenar o mejorar sistemas de IA sin licencia expresa.</li>
        </ul>
      </section>

      <section id="compras" className="legal-section">
        <h2>4. Compras y precios</h2>
        <p>
          Los precios se muestran en <strong>pesos argentinos (ARS)</strong> e incluyen o no impuestos
          según se indique en cada caso. Las compras de impresiones, servicios o libros se confirman
          a través de los medios habilitados en el sitio (por ejemplo, WhatsApp/checkout) y quedan
          sujetas a disponibilidad, validación del pago y confirmación final.
        </p>
        <p>
          Las imágenes se venden como <strong>impresiones</strong>. La
          adquisición de una impresión <strong>no transfiere</strong> derechos de autor sobre la obra.
        </p>
      </section>

      <section id="envios" className="legal-section">
        <h2>5. Envíos y plazos</h2>
        <p>
          El costo y plazo del envío se calculan en el checkout o durante la confirmación por el
          canal de compra. Los plazos son estimados y pueden variar por motivos logísticos o de
          producción (en especial para productos personalizados).
        </p>
      </section>

      <section id="cambios" className="legal-section">
        <h2>6. Cambios, cancelaciones y devoluciones</h2>
        <p>
          Debido a la naturaleza de las <strong>impresiones y productos personalizados</strong>,
          solo se aceptarán cambios o devoluciones en caso de <strong>defecto de fabricación
          o daño</strong> durante el transporte, reportado dentro de los plazos indicados al
          momento de la compra. Las cancelaciones estarán sujetas al estado del pedido.
        </p>
      </section>

      <section id="cuentas" className="legal-section">
        <h2>7. Cuentas de usuario</h2>
        <p>
          Sos responsable de mantener la confidencialidad de tus credenciales y del uso de tu cuenta.
          Informanos de inmediato sobre cualquier uso no autorizado. Podemos suspender o cancelar
          cuentas que incumplan estos términos.
        </p>
      </section>

      <section id="responsabilidad" className="legal-section">
        <h2>8. Responsabilidad</h2>
        <p>
          El sitio se ofrece “tal cual”. No garantizamos disponibilidad continua ni ausencia de
          errores. En la máxima medida permitida por la ley, no seremos responsables por pérdidas
          indirectas o lucro cesante derivadas del uso del sitio o de productos adquiridos, salvo
          cuando la normativa aplicable disponga lo contrario.
        </p>
      </section>

      <section id="jurisdiccion" className="legal-section">
        <h2>9. Ley aplicable</h2>
        <p>
          Estos Términos se regirán por las leyes vigentes en la <strong>República Argentina</strong>,
          sin perjuicio de las normas de derecho internacional privado que pudieran corresponder.
          Toda controversia será sometida a los tribunales competentes del domicilio del titular del sitio,
          salvo disposición legal imperativa distinta.
        </p>
      </section>

      <section id="contacto" className="legal-section">
        <h2>10. Contacto</h2>
        <p>
          ¿Dudas sobre licencias, compras o envíos? Escribinos:
          {' '}
          <a href="mailto:contacto@tu-dominio.com">juanipavlovsky@hotmail.com</a>
          {' '}o por WhatsApp al{' '}
          <a href="https://wa.me/5491160035550" target="_blank" rel="noreferrer">+54 9 11 6003-5550</a>.
        </p>
        <p className="legal-small">
          Si creés que algún contenido infringe tus derechos, enviá un aviso con la URL, descripción de la obra y
          datos de contacto para que podamos gestionarlo (procedimiento de “notice &amp; takedown”).
        </p>
        <p className="legal-back">
          <Link to="/">Volver al inicio</Link>
        </p>
      </section>
    </main>
  );
};

export default Copyright;
